import React, { useState, useCallback, useEffect } from 'react'
import { useModal } from 'react-modal-hook'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import PortfolioService from '../../services/portfolio.service'
import { Formik, Field, Form } from 'formik'
import { AddAccountNameSchema } from '../../schemas/index'
import InputError from '../../components/InputError/InputError'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoInput from '../../components/NeoInput/NeoInput'
import NeoLoader from '../../components/FormComponents/NeoLoader'
import { useHistory } from 'react-router-dom'
import Modal from '../../components/Modal/Modal'
import { getAccountListSelector } from '../../store/selectors/app.selector'
import { useDispatch, useSelector } from 'react-redux'
import { NeoSuccess } from '../../components/FormComponents'
import { setIsAcctRefresh } from '../../store/actions/app.actions'
import validationConfig from 'custom/config/validation.config.json'
const setAccountNameConfig = validationConfig['setAccountName']
import { useTranslation } from 'react-i18next'
import { BUTTON_KEYS, SET_ACCOUNT_NAME_KEYS } from '../../utils/translation-constants'

export default function AccountName() {
  const history = useHistory()
  const dispatch = useDispatch()
  const accountDetails = useSelector(getAccountListSelector) || []
  const [loading, setLoading] = useState(false)
  // const [accountDetails, setAccountDetails] = useState([])
  const [createNickName, setCreateNickName] = useState()
  const [stage, setStage] = useState(1)
  const [message, setMessage] = useState('')
  const { t } = useTranslation()
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6 className='text-center'>{message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
                history.push('/dashboard')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  // useEffect(() => {
  //   getAccountDetails()
  // }, [])

  // const getAccountDetails = useCallback(async (values) => {
  //   try {
  //     const response = await PortfolioService.getAccountDetails({
  //       fetchDeposits: false,
  //       fetchLoans: false,
  //       fetchSavings: true,
  //     })
  //     if (response.status === 200) {
  //       setAccountDetails(response.data['accountSummaryList'])
  //     }
  //   } catch (err) {
  //     console.error(err)
  //   }
  // }, [])

  const createAccountNickName = useCallback(
    async (values, { setSubmitting }) => {
      setLoading(true)
      setSubmitting(true)
      try {
        const response = await PortfolioService.createAccountNickName(values)
        if (response.status === 200) {
          setCreateNickName(response.data)
          dispatch(setIsAcctRefresh(true))
          setMessage(response.data['message'])
          setSubmitting(false)
          setLoading(false)
          setStage(2)
        }
      } catch (err) {
        setSubmitting(false)
        setLoading(false)
        // setMessage(err.data.message)
        // //showModal()
      }
    },
    [showModal],
  )

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return <NeoSuccess message={message} linkPath='/accounts' />
      default:
        return renderForm()
    }
  }


  function renderForm() {
    return (
      <Formik
        initialValues={{
          accountNumber: '',
          accountNickName: '',
        }}
        validationSchema={AddAccountNameSchema}
        onSubmit={createAccountNickName}>
        {({ isSubmitting, errors, touched, handleChange }) => (
          <Form>
            <div className='d-flex row'>
              <div className='col-12'>
                <div className='form-group my-2'>
                  <label className='control-label'>{t(SET_ACCOUNT_NAME_KEYS.ACCOUNT_NO)} {setAccountNameConfig['isAccountNoRequired'] ? '*' : ''}</label>
                  <Field
                    as='select'
                    className='form-control'
                    name='accountNumber'
                    disabled={loading}
                    placeholder={t(SET_ACCOUNT_NAME_KEYS.SELECT_ACCOUNT_NO)}>
                    <option disabled value='' />
                    {accountDetails.map((item, index) => (
                      <option key={index} value={item.accountNo}>
                        {item.accountNo}
                      </option>
                    ))}
                  </Field>
                  <InputError text={errors.accountNumber} touched={touched.accountNumber} />
                </div>
                <div className='form-group my-2'>
                  <NeoInput
                    showAsterisk={setAccountNameConfig['isShortNameRequired']}
                    text={t(SET_ACCOUNT_NAME_KEYS.SHORT_NAME)}
                    onChange={handleChange}
                    name='accountNickName'
                    minLength={2}
                    maxLength={20}
                    onKeyPress={(event) => {
                      if (
                        !(event.charCode >= 65 && event.charCode <= 90) &&
                        !(event.charCode >= 97 && event.charCode <= 122) &&
                        event.charCode !== 32
                      ) {
                        event.preventDefault()
                      }
                    }}
                  />
                  <InputError touched={touched.accountNickName} text={errors.accountNickName} />
                </div>
                <div className='mt-5'>
                  {loading ? (
                    <NeoLoader />
                  ) : (
                    <NeoButton type='button' mode='newDesign' type='submit' text={t(BUTTON_KEYS.SUBMIT)} />
                  )}
                </div>
                <div className='back-cancel-style' onClick={() => history.goBack()}>
                {t(BUTTON_KEYS.CANCEL)}{' '}
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='SET_ACCOUNT_NAME'
      keyPath={'SET_ACCOUNT_NAME'}
      showEmptySpace={true}>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(SET_ACCOUNT_NAME_KEYS.HEADER)}</div>
        {renderSwitch()}
      </div>
    </LayoutWithOutAccountCard>
  )
}
